import { Link } from "react-router-dom";
import { checkButtonAccess, renderStatus } from "../../../Utils/CommonUtils";
import { DeleteListIcon } from "../../../assets/images/svg/svg";
import { deleteOrder } from "../../Order/Orders/OrderService";
import { deleteAgMember } from "../AgMemberService";
import { useState } from "react";
import ConfirmationModalDelete from "../../../Components/Common/Modal/SaveChangesModal";

const ActionCell = ({ entityid }) => {
  const [showModal, setShowModal] = useState(false);

  const handleDeleteConfirm = () => {
    deleteAgMember(entityid);
    setShowModal(false);
  };

  return (
    <>
      <div className="d-flex gap-4 align-items-center">
        {(checkButtonAccess
          ? checkButtonAccess("DELETE", "AGM_MEM")
          : true) && (
          <span onClick={() => setShowModal(true)}>
            <DeleteListIcon />
          </span>
        )}
      </div>

      <ConfirmationModalDelete
        isOpen={showModal}
        message="Are you sure you want to delete this member?"
        onConfirm={handleDeleteConfirm}
        onCancel={() => setShowModal(false)}
      />
    </>
  );
};

const useAgMemberColumns = () => {
  const agMemberColumns = [
    {
      header: "Code",
      accessorKey: "code",
      cell: (props) => (
        <Link
          className="table-drilling-link"
          to={`/agmember/member/update/${props.row.original.entityid}`}
        >
          {props?.getValue() ? props?.getValue() : "-"}
        </Link>
      ),
      size: 200,
    },
    // {
    //   header: "Membership No.",
    //   accessorKey: "membership_number",
    //   cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
    //   size: 200,
    // },
    {
      header: "Membership Number",
      accessorKey: "membership_number",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Contact Number",
      accessorKey: "contact",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    // {
    //   header: "Created Date",
    //   accessorKey: "created_date",
    //   // cell: (props) => {
    //   //   {props?.getValue() ? props?.getValue() : "-"}
    //   // },
    //   size: 200,
    // },
    {
      header: "Email",
      accessorKey: "email_id",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: (props) =>
        props?.getValue() ? renderStatus(props?.getValue()) : "-",
      size: 100,
    },
    {
      header: "Action",
      accessorKey: "action",
      cell: (props) => <ActionCell entityid={props.row.original.entityid} />,
    },
  ];

  return { agMemberColumns };
};
export default useAgMemberColumns;
